import { render, staticRenderFns } from "./PublishableEntityModal.vue?vue&type=template&id=6ab42bdc&"
import script from "./PublishableEntityModal.vue?vue&type=script&lang=js&"
export * from "./PublishableEntityModal.vue?vue&type=script&lang=js&"
import style0 from "./PublishableEntityModal.vue?vue&type=style&index=0&id=6ab42bdc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports